module.exports = __webpack_public_path__ + "static/media/IC205amg.84a6fb82.jpg";